import React from 'react';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { StockLocation } from '../types/stock_location';
import { StockLocationContext, StockLocationContextProps } from '../context/StockLocationContext';

const stockLocationState = {
  items: new Map<string, StockLocation>(),
  loading: false,
};

export const stockLocationSlice = createSlice({
  name: 'stockLocation',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      stockLocationState.items = new Map();
      stockLocationState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<StockLocation[]>) => {
      stockLocationState.items = new Map();
      action.payload.forEach(p => stockLocationState.items.set(p.id, new StockLocation(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<StockLocation[]>) => {
      action.payload.forEach(p => stockLocationState.items.set(p.id, new StockLocation(p)));
      stockLocationState.items = new Map(stockLocationState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<StockLocation[]>) => {
      action.payload.forEach(p => stockLocationState.items.delete(p.id));
      stockLocationState.items = new Map(stockLocationState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      stockLocationState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface StockLocationProviderProps {
  children: React.ReactNode;
}

export default function StockLocationProvider({ children }: StockLocationProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.stockLocations.key);

  const stockLocationContext: StockLocationContextProps = {
    stockLocations: stockLocationState.items,
    stockLocationsLoading: stockLocationState.loading,
    setStockLocations: (stockLocations: Map<string, StockLocation>) => {
      dispatch(stockLocationSlice.actions.set([...stockLocations.values()]));
    },
  };

  return <StockLocationContext.Provider value={stockLocationContext}>{children}</StockLocationContext.Provider>;
}
